/* Solvea Paris — Offre : paliers, teintes DANS chaque carte (pastille couleur), cadeaux à débloquer.
   Ajout panier : /cart/add.js puis RE-RENDU du tiroir panier Horizon via la Section Rendering API
   (le tiroir n'écoute que l'événement interne du thème — sans re-rendu il affichait « Votre panier est vide »). */
(function () {
  'use strict';

  function eur(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

  /* Rafraîchit le tiroir panier (section cart-drawer-section) et l'icône du header, puis ouvre le tiroir. */
  function rafraichirPanier() {
    var ids = ['cart-drawer-section'];
    var head = document.querySelector('#header-group .shopify-section');
    if (head && head.id) ids.push(head.id.replace('shopify-section-', ''));
    return fetch('/?sections=' + ids.join(','), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json['cart-drawer-section'];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var neuf = doc.querySelector('cart-drawer-component');
          var actuel = document.querySelector('cart-drawer-component');
          if (neuf && actuel) actuel.innerHTML = neuf.innerHTML;
          else {
            var sec = document.getElementById('shopify-section-cart-drawer-section');
            if (sec) sec.innerHTML = doc.body.firstElementChild ? doc.body.firstElementChild.innerHTML : html;
          }
        }
        if (ids[1] && json[ids[1]]) {
          var d2 = new DOMParser().parseFromString(json[ids[1]], 'text/html');
          var nIcon = d2.querySelector('cart-icon, .header-actions__cart-icon, [ref="cartIcon"]');
          var aIcon = document.querySelector('cart-icon, .header-actions__cart-icon, [ref="cartIcon"]');
          if (nIcon && aIcon) aIcon.replaceWith(nIcon);
        }
      })
      .catch(function () {})
      .then(function () {
        var tiroir = document.getElementById('cart-drawer') || document.querySelector('theme-drawer[id*="cart"]');
        if (tiroir && typeof tiroir.open === 'function') tiroir.open();
        else if (tiroir && tiroir.querySelector('dialog') && typeof tiroir.querySelector('dialog').showModal === 'function') tiroir.querySelector('dialog').showModal();
        else window.location.href = '/cart';
      });
  }

  function init(root) {
    if (!root || root.dataset.slvPret === '1') return;
    root.dataset.slvPret = '1';

    var cartes = root.querySelectorAll('[data-slv-carte]');
    var cadeaux = root.querySelectorAll('[data-slv-cadeau]');
    var tpl = root.querySelector('[data-slv-teinte-tpl]');
    var compte = root.querySelector('[data-slv-compte]');
    var bar = root.querySelector('[data-slv-bar]');
    var fill = root.querySelector('[data-slv-fill]');
    var btxt = root.querySelector('[data-slv-btxt]');
    var bouton = root.querySelector('[data-slv-ajouter]');
    var etat = root.querySelector('[data-slv-etat]');

    function actif() { return root.querySelector('[data-slv-carte].on') || cartes[0]; }
    function zoneDe(carte) { return carte ? carte.querySelector('[data-slv-teintes-zone]') : null; }

    function couleurDe(nom) {
      var n = (nom || '').trim().toLowerCase();
      var b = Array.prototype.find.call(root.querySelectorAll('[data-slv-sw-teinte]'), function (x) { return x.dataset.slvSwTeinte.trim().toLowerCase() === n; });
      return b ? b.style.background : '#1A1A1A';
    }
    function pastille(sel) {
      var dot = sel.parentElement ? sel.parentElement.querySelector('[data-slv-dot]') : null;
      if (!dot) return;
      var opt = sel.options[sel.selectedIndex];
      dot.style.background = couleurDe(opt ? opt.text : '');
    }

    function rendreTeintes(carte) {
      var zoneT = zoneDe(carte);
      if (!tpl || !zoneT) return;
      var qte = parseInt(carte.dataset.slvQte, 10) || 1;
      var anciens = [];
      zoneT.querySelectorAll('select[data-slv-variante]').forEach(function (s) { anciens.push(s.value); });
      if (zoneT.children.length === qte && anciens.length === qte) { zoneT.querySelectorAll('select[data-slv-variante]').forEach(pastille); return; }
      var sw = root.querySelector('[data-slv-sw-teinte].on');
      var swNom = sw ? sw.dataset.slvSwTeinte.trim().toLowerCase() : '';
      zoneT.innerHTML = '';
      var label = zoneT.getAttribute('data-slv-label') || 'Teinte';
      for (var i = 0; i < qte; i++) {
        var n = tpl.content.cloneNode(true);
        var lab = n.querySelector('[data-slv-ch-label]');
        if (lab) lab.textContent = label.indexOf('[n]') > -1 ? label.split('[n]').join(i + 1) : (qte > 1 ? label + ' ' + (i + 1) : label);
        var sel = n.querySelector('select[data-slv-variante]');
        if (sel) {
          if (anciens[i]) sel.value = anciens[i];
          else if (swNom) { for (var k = 0; k < sel.options.length; k++) { if (sel.options[k].text.trim().toLowerCase() === swNom) { sel.value = sel.options[k].value; break; } } }
        }
        zoneT.appendChild(n);
      }
      zoneT.querySelectorAll('select[data-slv-variante]').forEach(pastille);
    }
    root.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('select[data-slv-variante]')) pastille(e.target); });

    function peindre() {
      var sel = actif();
      if (!sel) return;
      var palier = parseInt(sel.dataset.slvPalier, 10) || 1;
      var prix = parseInt(sel.dataset.slvPrix, 10) || 0;
      var ouverts = 0;
      cadeaux.forEach(function (g) {
        var depuis = parseInt(g.dataset.slvDepuis, 10) || 1;
        var verrou = palier < depuis;
        if (!verrou) ouverts++;
        g.classList.toggle('is-verrou', verrou);
        var lbl = g.querySelector('[data-slv-glabel]');
        if (lbl) lbl.textContent = verrou ? (g.dataset.slvVerrouTxt || 'À débloquer') : (g.dataset.slvOffertTxt || 'Offert');
      });
      if (compte) compte.textContent = cadeaux.length ? ouverts + ' / ' + cadeaux.length + ' débloqués' : '';
      if (!bar) return;
      var seuil = parseInt(bar.dataset.slvSeuil, 10) || 0;
      if (seuil <= 0) return;
      var pct = Math.max(0, Math.min(100, Math.round((prix * 100) / seuil)));
      if (fill) fill.style.width = pct + '%';
      var ok = prix >= seuil;
      bar.classList.toggle('is-ok', ok);
      if (!btxt) return;
      if (ok) { btxt.textContent = bar.dataset.slvOk || ''; }
      else { var t = bar.dataset.slvReste || ''; btxt.innerHTML = t.split('[manque]').join('<b>' + eur(seuil - prix) + '</b>'); }
    }

    function choisir(c) {
      cartes.forEach(function (o) {
        var on = o === c;
        o.classList.toggle('on', on);
        o.setAttribute('aria-checked', on ? 'true' : 'false');
        o.setAttribute('tabindex', on ? '0' : '-1');
      });
      rendreTeintes(c);
      peindre();
    }

    cartes.forEach(function (c) {
      c.addEventListener('click', function (e) {
        if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION') return;
        if (e.target.closest && e.target.closest('[data-slv-teintes-zone]')) return;
        choisir(c);
      });
      c.addEventListener('keydown', function (e) {
        if (e.target.tagName === 'SELECT') return;
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); choisir(c); return; }
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown' || e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          var liste = Array.prototype.slice.call(cartes);
          var i = liste.indexOf(c);
          var pas = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
          var suiv = liste[(i + pas + liste.length) % liste.length];
          if (suiv) { choisir(suiv); suiv.focus(); }
        }
      });
    });

    cartes.forEach(function (c) { rendreTeintes(c); });
    var pre = actif();
    if (pre) choisir(pre);

    if (!bouton) return;
    bouton.addEventListener('click', function () {
      var sel = actif();
      if (!sel) return;
      var articles = [];
      var zone = zoneDe(sel);
      var selects = zone ? zone.querySelectorAll('select[data-slv-variante]') : [];
      if (selects.length) {
        selects.forEach(function (s) { articles.push({ id: Number(s.value), quantity: 1 }); });
      } else {
        articles.push({ id: Number(sel.dataset.slvVariante), quantity: Number(sel.dataset.slvQte || 1) });
      }
      var palier = parseInt(sel.dataset.slvPalier, 10) || 1;
      cadeaux.forEach(function (g) {
        var depuis = parseInt(g.dataset.slvDepuis, 10) || 1;
        var vid = Number(g.dataset.slvVid || 0);
        if (vid > 0 && palier >= depuis) articles.push({ id: vid, quantity: 1 });
      });

      bouton.disabled = true;
      var libelle = bouton.textContent;
      bouton.textContent = 'Ajout en cours…';
      if (etat) etat.textContent = '';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: articles })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
          return rafraichirPanier();
        })
        .catch(function () {
          if (etat) etat.textContent = "L'ajout au panier n'a pas fonctionné. Merci de réessayer.";
        })
        .then(function () {
          bouton.disabled = false;
          bouton.textContent = libelle;
        });
    });
  }

  function tout() { document.querySelectorAll('[data-slv-offre]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
  else tout();
  document.addEventListener('shopify:section:load', tout);
  document.addEventListener('shopify:block:select', tout);
})();
